import M24CompanyTab from "components/company/CompanyTab";
import DepartmentRequestDoc from "components/department-request-document/UploadDucumentStep";
import DocumentList from "components/request-document/DocumentList";
import ExecutiveSummarizeStep from "components/request-document/executive/SummarizeStep";
import ExecutiveSurveyStep from "components/request-document/executive/SurveyStep";
import ExecutiveUploadDucumentStep from "components/request-document/executive/UploadDucumentStep";
import ExecutiveUploadPassport from "components/request-document/executive/UploadPassport";
import ExecutiveUserProfileStep from "components/request-document/executive/UserProfileStep";
import ExecutiveUserProfileStep2 from "components/request-document/executive/UserProfileStep2";
import ExecutiveUserProfileStepB from "components/request-document/executive/UserProfileStepB";
import ExecutiveUserProfileStepC from "components/request-document/executive/UserProfileStepC";
import InvestorSummarizeStep from "components/request-document/investor/SummarizeStep";
import InvestorSurveyStep from "components/request-document/investor/SurveyStep";
import InvestorUploadDucumentStep from "components/request-document/investor/UploadDucumentStep";
import InvestorUploadPassport from "components/request-document/investor/UploadPassport";
import InvestorUserProfileStep from "components/request-document/investor/UserProfileStep";
import InvestorUserProfileStep2 from "components/request-document/investor/UserProfileStep2";
import InvestorUserProfileStepB from "components/request-document/investor/UserProfileStepB";
import InvestorUserProfileStepC from "components/request-document/investor/UserProfileStepC";
import InvestorVisaIssuanceStep from "components/request-document/investor/VisaIssuanceStep";
import OtherSummarizeStep from "components/request-document/other/SummarizeStep";
import OtherSurveyStep from "components/request-document/other/SurveyStep";
import OtherUploadDucumentStep from "components/request-document/other/UploadDucumentStep";
import OtherUploadPassport from "components/request-document/other/UploadPassport";
import OtherUserProfileStep from "components/request-document/other/UserProfileStep";
import OtherUserProfileStepB from "components/request-document/other/UserProfileStepB";
import StartUpHealthInsuranceStep from "components/request-document/startup/HealthInsuranceStep";
import StartUpSummarizeStep from "components/request-document/startup/SummarizeStep";
import StartUpSurveyStep from "components/request-document/startup/SurveyStep";
import StartUpUploadDucumentStep from "components/request-document/startup/UploadDucumentStep";
import StartUpUploadPassport from "components/request-document/startup/UploadPassport";
import StartUpUserProfileStep from "components/request-document/startup/UserProfileStep";
import StartUpUserProfileStep2 from "components/request-document/startup/UserProfileStep2";
import StartUpUserProfileStepB from "components/request-document/startup/UserProfileStepB";
import StartUpUserProfileStepC from "components/request-document/startup/UserProfileStepC";
import StartUpUserProfileStepD from "components/request-document/startup/UserProfileStepD";
import UserProfileStepE from "components/request-document/startup/UserProfileStepE";
import StartUpVisaIssuanceStep from "components/request-document/startup/VisaIssuanceStep";
import TalentSummarizeStep from "components/request-document/talent/SummarizeStep";
import TalentSurveyStep from "components/request-document/talent/SurveyStep";
import TalentUploadDucumentStep from "components/request-document/talent/UploadDucumentStep";
import TalentUploadPassport from "components/request-document/talent/UploadPassport";
import TalentUserProfileStep from "components/request-document/talent/UserProfileStep";
import TalentUserProfileStep2 from "components/request-document/talent/UserProfileStep2";
import TalentUserProfileStepB from "components/request-document/talent/UserProfileStepB";
import TalentUserProfileStepC from "components/request-document/talent/UserProfileStepC";
import M24EmployeeList from "components/section-m-24/EmployeeList";
import M24TerminationStep from "components/section-m-24/TerminationStep";
import M24UploadDucument from "components/section-m-24/UploadDucument";
import M24UploadPassport from "components/section-m-24/UploadPassport";
import M24UserProfileStep from "components/section-m-24/UserProfileStep";
import M24UserProfileStep2 from "components/section-m-24/UserProfileStep2";
import M24VisaIssuanceStep from "components/section-m-24/VisaIssuanceStep";
import ChangeAddCompanyInvestmentStep from "components/smart-visa-change/AddCompanyInvestmentStep";
import ChangeAddJobPositionStep from "components/smart-visa-change/AddJobPositionStep";
import ChangeUpdateCompanyInfoStep from "components/smart-visa-change/UpdateCompanyInfoStep";
import ChangeUpdateJobPositionStep from "components/smart-visa-change/UpdateJobPositionStep";
import ChangeUploadDucumentStep from "components/smart-visa-change/UploadDucumentStep";
import FromA from "components/smart-visa-extension/FromA";
import ExtensionHealthInsuranceStep from "components/smart-visa-extension/HealthInsuranceStep";
import PartA from "components/smart-visa-extension/PartA";
import PartB from "components/smart-visa-extension/PartB";
import PartC from "components/smart-visa-extension/PartC";
import PartD from "components/smart-visa-extension/PartD";
import PartE from "components/smart-visa-extension/PartE";
import PartF from "components/smart-visa-extension/PartF";
import PartG from "components/smart-visa-extension/PartG";
import PartUploadDucument from "components/smart-visa-extension/PartUploadDucument";
import { STATUS_PROCESS } from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import _ from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import {
  selectIsChange,
  selectIsExtension,
  selectIsM24,
  selectSmartFormStep,
} from "redux/modules/uiSlice";
import {
  selectCurrentSmartForm,
  selectCurrentSmartServiceId,
  selectSmartService,
} from "redux/modules/visaForm";

export function SectionM24Step() {
  const smartFormStep = useSelector(selectSmartFormStep);

  console.log(smartFormStep);
  switch (smartFormStep) {
    case SMART_T_STEP.INSTITUTION_COMPANY:
      return <M24CompanyTab id="INSTITUTION_COMPANY" />;
    case SMART_T_STEP.COMPANY_UPLOAD_DOCUMENT:
      return <M24CompanyTab id="COMPANY_UPLOAD_DOCUMENT" isUploadDoc />;
    case SMART_T_STEP.EMPLOYEE_LIST:
      return <M24EmployeeList />;
    case SMART_T_STEP.UPLOAD_PASSPORT:
      return <M24UploadPassport />;
    case SMART_T_STEP.PART_A_1:
      return <M24UserProfileStep />;
    case SMART_T_STEP.PART_A_2:
      return <M24UserProfileStep2 />;
    case SMART_T_STEP.VISA_INSUANCE:
      return <M24VisaIssuanceStep />;
    case SMART_T_STEP.TERMINATION:
      return <M24TerminationStep />;
    case SMART_T_STEP.UPLOAD_DOCUMENT:
      return <M24UploadDucument />;
    default:
      return <DocumentList />;
  }
}

function DepartmentRequestDocStep() {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case SMART_T_STEP.UPLOAD_DOCUMENT:
      return <DepartmentRequestDoc />;
    default:
      return <DocumentList />;
  }
}

function ExtensionStep() {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case SMART_T_STEP.PART_A_1:
      return <PartA />;
    case SMART_T_STEP.PART_B:
      return <PartB />;
    case SMART_T_STEP.PART_C:
      return <PartC />;
    case SMART_T_STEP.PART_D:
      return <PartD />;
    case SMART_T_STEP.PART_E:
      return <PartE />;
    case SMART_T_STEP.PART_F:
      return <PartF />;
    case SMART_T_STEP.PART_G:
      return <PartG />;
    case SMART_T_STEP.FROM_A:
      return <FromA />;
    case SMART_T_STEP.HEALTH_INSUANCE:
      return <ExtensionHealthInsuranceStep />;
    case SMART_T_STEP.UPLOAD_DOCUMENT:
      return <PartUploadDucument />;
    default:
      return <DocumentList />;
  }
}

function ChangeStep() {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case SMART_T_STEP.ADD_JOB_POSITION:
      return <ChangeAddJobPositionStep />;
    case SMART_T_STEP.UPDATE_JOB_POSITION:
      return <ChangeUpdateJobPositionStep />;
    case SMART_T_STEP.UPDATE_COMPANY_INFO:
      return <ChangeUpdateCompanyInfoStep />;
    case SMART_T_STEP.ADD_COMPAMY_INVESTMENT:
      return <ChangeAddCompanyInvestmentStep />;
    case SMART_T_STEP.UPLOAD_DOCUMENT:
      return <ChangeUploadDucumentStep />;
    default:
      return <DocumentList />;
  }
}

function SmartSStep() {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case SMART_T_STEP.UPLOAD_PASSPORT:
      return <StartUpUploadPassport />;
    case SMART_T_STEP.PART_A_1:
      return <StartUpUserProfileStep />;
    case SMART_T_STEP.PART_A_2:
      return <StartUpUserProfileStep2 />;
    case SMART_T_STEP.PART_B:
      return <StartUpUserProfileStepB />;
    case SMART_T_STEP.PART_C:
      return <StartUpUserProfileStepC />;
    case SMART_T_STEP.PART_D:
      return <StartUpUserProfileStepD />;
    case SMART_T_STEP.PART_E:
      return <UserProfileStepE />;
    case SMART_T_STEP.UPLOAD_DOCUMENT:
      return <StartUpUploadDucumentStep />;
    case SMART_T_STEP.SURVEY:
      return <StartUpSurveyStep />;
    case SMART_T_STEP.SUMMARIZE:
      return <StartUpSummarizeStep />;
    case SMART_T_STEP.VISA_INSUANCE:
      return <StartUpVisaIssuanceStep />;
    case SMART_T_STEP.HEALTH_INSUANCE:
      return <StartUpHealthInsuranceStep />;
    default:
      return <DocumentList />;
  }
}

function SmartOStep() {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case SMART_T_STEP.UPLOAD_PASSPORT:
      return <OtherUploadPassport />;
    case SMART_T_STEP.PART_A_1:
      return <OtherUserProfileStep />;
    case SMART_T_STEP.PART_B:
      return <OtherUserProfileStepB />;
    case SMART_T_STEP.UPLOAD_DOCUMENT:
      return <OtherUploadDucumentStep />;
    case SMART_T_STEP.SURVEY:
      return <OtherSurveyStep />;
    case SMART_T_STEP.SUMMARIZE:
      return <OtherSummarizeStep />;
    default:
      return <DocumentList />;
  }
}

function SmartIStep() {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case SMART_T_STEP.UPLOAD_PASSPORT:
      return <InvestorUploadPassport />;
    case SMART_T_STEP.PART_A_1:
      return <InvestorUserProfileStep />;
    case SMART_T_STEP.PART_A_2:
      return <InvestorUserProfileStep2 />;
    case SMART_T_STEP.PART_B:
      return <InvestorUserProfileStepB />;
    case SMART_T_STEP.PART_C:
      return <InvestorUserProfileStepC />;
    case SMART_T_STEP.UPLOAD_DOCUMENT:
      return <InvestorUploadDucumentStep />;
    case SMART_T_STEP.SURVEY:
      return <InvestorSurveyStep />;
    case SMART_T_STEP.VISA_INSUANCE:
      return <InvestorVisaIssuanceStep />;
    case SMART_T_STEP.SUMMARIZE:
      return <InvestorSummarizeStep />;
    default:
      return <DocumentList />;
  }
}

function SmartEStep() {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case SMART_T_STEP.UPLOAD_PASSPORT:
      return <ExecutiveUploadPassport />;
    case SMART_T_STEP.PART_A_1:
      return <ExecutiveUserProfileStep />;
    case SMART_T_STEP.PART_A_2:
      return <ExecutiveUserProfileStep2 />;
    case SMART_T_STEP.PART_B:
      return <ExecutiveUserProfileStepB />;
    case SMART_T_STEP.PART_C:
      return <ExecutiveUserProfileStepC />;
    case SMART_T_STEP.UPLOAD_DOCUMENT:
      return <ExecutiveUploadDucumentStep />;
    case SMART_T_STEP.SURVEY:
      return <ExecutiveSurveyStep />;
    case SMART_T_STEP.SUMMARIZE:
      return <ExecutiveSummarizeStep />;
    default:
      return <DocumentList />;
  }
}

function SmartTStep() {
  const smartFormStep = useSelector(selectSmartFormStep);

  switch (smartFormStep) {
    case SMART_T_STEP.UPLOAD_PASSPORT:
      return <TalentUploadPassport />;
    case SMART_T_STEP.PART_A_1:
      return <TalentUserProfileStep />;
    case SMART_T_STEP.PART_A_2:
      return <TalentUserProfileStep2 />;
    case SMART_T_STEP.PART_B:
      return <TalentUserProfileStepB />;
    case SMART_T_STEP.PART_C:
      return <TalentUserProfileStepC />;
    case SMART_T_STEP.UPLOAD_DOCUMENT:
      return <TalentUploadDucumentStep />;
    case SMART_T_STEP.SURVEY:
      return <TalentSurveyStep />;
    case SMART_T_STEP.SUMMARIZE:
      return <TalentSummarizeStep />;
    default:
      return <DocumentList />;
  }
}

export default function StepContainer() {
  const smartserviceId = useSelector(selectCurrentSmartServiceId);
  const smartService = useSelector(selectSmartService);
  const isExtension = useSelector(selectIsExtension);
  const isChange = useSelector(selectIsChange);
  const isM24 = useSelector(selectIsM24);
  const currentSmartForm = useSelector(selectCurrentSmartForm);
  const currentSmart = _.get(smartService, "data", []).find(
    (v) => v.smartserviceId === smartserviceId
  );
  const smartserviceName = _.get(currentSmart, "smartserviceName", "");
  const typeDocSmartFromID = _.get(currentSmartForm, "typeDocSmartFromID", "");
  const statausID = _.get(currentSmartForm, "statausID", "");

  if (statausID === STATUS_PROCESS.RequestAddDoc) {
    return <DepartmentRequestDocStep />;
  }

  if (isM24) {
    return <SectionM24Step />;
  }

  if (isExtension || typeDocSmartFromID === "E") {
    return <ExtensionStep />;
  }

  if (isChange || typeDocSmartFromID === "C") {
    return <ChangeStep />;
  }

  // DepartmentRequestDocStep
  switch (smartserviceName) {
    case "Smart T":
      return <SmartTStep />;
    case "Smart E":
      return <SmartEStep />;
    case "Smart I":
      return <SmartIStep />;
    case "Smart O":
      return <SmartOStep />;
    case "Smart S":
      return <SmartSStep />;
    default:
      return <SmartTStep />;
  }
}
